module.exports = __webpack_public_path__ + "static/img/aboutPageTeam.952a4ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/aboutPageTeam.jpg
// module id = vOAj
// module chunks = 3